import React, { useState, useEffect } from 'react';
import { Alert, Col, Form, Row } from 'antd';
import { useFormSociogramPage, useSelectedResponses } from '@BUP/hooks';
import { useTranslation } from 'react-i18next';
import { ADD_RESPONSE, REMOVE_RESPONSE } from '@BUP/constants';
import { findAnswerByHasExternalList } from '@BUP/services/BraveUp/Sociogram';
import { ButtonsSociogram, QuestionElement } from '@BUP/components';
import styles from './questions-list.module.css';

const QuestionsList = ({
  title,
  questions,
  // onPreviousPage,
  onSubmitResponses,
  onSubmit,
  classMates,
}) => {
  const [, forceUpdate] = useState();
  const { form } = useFormSociogramPage();
  const {
    selectedResponses,
    dispatchSelectedResponses,
  } = useSelectedResponses();
  const [t] = useTranslation();
  useEffect(() => {
    forceUpdate({});
    form.resetFields();
  }, []);

  questions?.sort((obj1, obj2) => {
    if (obj1.position < obj2.position) {
      return -1;
    }
    if (obj1.position > obj2.position) {
      return 1;
    }
    return 0;
  });

  // maneja cada pregunta independiente del tipo, si es padre o hija
  const handleChangeQuestionResponse = (name, question, answerId, values) => {
    const questionType = question?.question_textId?.type;
    const questionName =
      questionType === 'check' ? `${name}-checkId-${answerId}` : name;
    if (answerId) {
      const filterAnswer = question?.question_textId?.answers.find(
        (answer) => answer.id === answerId
      );
      if (questionType === 'check') {
        const hasResponse = selectedResponses.some(
          (element) => element.responseId === questionName
        );
        if (!hasResponse) {
          dispatchSelectedResponses({
            type: ADD_RESPONSE,
            payload: {
              ...filterAnswer,
              responseId: questionName,
              questionType: question?.question_textId?.type,
              isChildren: question?.isChildren,
              question,
              content: values && values?.[0] ? [...values] : [],
            },
          });
        } else {
          form.resetFields([questionName]);
          dispatchSelectedResponses({
            type: REMOVE_RESPONSE,
            payload: {
              responseId: questionName,
            },
          });
        }
      } else {
        dispatchSelectedResponses({
          type: ADD_RESPONSE,
          payload: {
            ...filterAnswer,
            responseId: questionName,
            questionType: question?.question_textId?.type,
            isChildren: question?.isChildren,
            question,
            content: values && values?.[0] ? [...values] : [],
          },
        });
      }
    }
    if (values) {
      if (!values.length) form.setFieldsValue({ [questionName]: undefined });
      const questionDependencies = question?.dependencies;
      questionDependencies.forEach((currentDependency) => {
        const dependencyType = currentDependency?.question_textId?.type;
        const associatesResponses = selectedResponses.filter(
          (response) =>
            response.isChildren === true &&
            response?.question?.question_textId?.id ===
              currentDependency?.question_textId?.id
        );
        const mustRemoveResponses = values.reduce(
          (acc, value) => {
            const classMate = value;
            const filteredResponses = acc.filter((response) => {
              const dependencyId =
                dependencyType === 'check'
                  ? `dependency-${question?.question_textId?.id}-question-${response?.question?.question_textId?.id}-classmate-${classMate?.enrollmentId}-checkId-${response.id}`
                  : `dependency-${question?.question_textId?.id}-question-${response?.question?.question_textId?.id}-classmate-${classMate?.enrollmentId}`;
              return response.responseId !== dependencyId;
            });
            return filteredResponses;
          },
          [...associatesResponses]
        );
        if (mustRemoveResponses.length) {
          // console.log('question', name, question);
          // console.log('currentDependency', currentDependency);
          // console.log('associatesResponses', associatesResponses);
          // console.log('values', values);
          // console.log('mustRemoveResponses', mustRemoveResponses);
          // console.log(
          //   `dependency-${question?.question_textId?.id}-question-${currentDependency?.question_textId?.id}-classmate-${mustRemoveResponses[0]?.content[0]?.enrollmentId}`
          // );
          if (dependencyType === 'check') {
            const forceResetField = `dependency-${question?.question_textId?.id}-question-${currentDependency?.question_textId?.id}-classmate-${mustRemoveResponses[0]?.content[0]?.enrollmentId}`;
            form.resetFields([forceResetField]);
          }
          mustRemoveResponses.forEach((response) => {
            form.resetFields([response.responseId]);
            dispatchSelectedResponses({
              type: REMOVE_RESPONSE,
              payload: {
                responseId: response.responseId,
              },
            });
          });
        }
      });
    }
  };

  // setea como valor inicial las preguntas padres que tengan como opcion "nadie", en el state selectedResponses
  const setQuestionsWhitSelect = (questions) => {
    questions.forEach((question) => {
      if (question && question?.question_textId) {
        const nothingAnswer = findAnswerByHasExternalList(
          question?.question_textId?.answers,
          false
        );
        handleChangeQuestionResponse(
          `question-${question?.question_textId?.id}`,
          question,
          nothingAnswer?.id
        );
      }
    });
  };

  useEffect(() => {
    setQuestionsWhitSelect(questions);
  }, []);

  // useEffect(() => {
  //   console.log('respuestas en mi state', selectedResponses);
  // }, [selectedResponses]);

  return (
    <div className={styles.container}>
      {title && <h2 className={styles.title_name}>{title}</h2>}
      {questions && questions.length ? (
        <div className={styles.questions__wrapper}>
          <Form form={form} onFinish={() => onSubmit(selectedResponses)}>
            {questions &&
              questions.map((question) => (
                <QuestionElement
                  key={`question-element-${question?.question_textId?.id}`}
                  type={question?.question_textId?.type}
                  question={question}
                  onChangeQuestionResponse={handleChangeQuestionResponse}
                  hasMe={question?.question_textId?.hasMe}
                  classMates={classMates}
                />
              ))}
            <Form.Item>
              <Row type="flex" justify="end">
                <Col span={18} align="middle">
                  <Alert
                    message={t('pages.data.answerSociogram.warningMessage')}
                    type="warning"
                    showIcon
                    closable
                  />
                </Col>
                <Col span={4}>
                  <ButtonsSociogram
                    onNextButton={onSubmitResponses}
                    // onBackButton={onPreviousPage}
                  />
                </Col>
              </Row>
            </Form.Item>
          </Form>
        </div>
      ) : (
        <div className={styles.no_questions__wrapper}>
          <h2>{t('pages.data.answerSociogram.noQuestions')}</h2>
        </div>
      )}
    </div>
  );
};

export default QuestionsList;
